"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledCard = require("./StyledCard");
var _Icon = _interopRequireDefault(require("../Icon"));
var _excluded = ["children", "bordered", "title", "hoverable", "onClick", "selected", "cover", "className", "extra", "extraPosition", "mode", "withArrow", "borderColor", "id"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Card = function Card(props) {
  var children = props.children,
    bordered = props.bordered,
    title = props.title,
    hoverable = props.hoverable,
    onClick = props.onClick,
    selected = props.selected,
    cover = props.cover,
    className = props.className,
    extra = props.extra,
    extraPosition = props.extraPosition,
    mode = props.mode,
    withArrow = props.withArrow,
    borderColor = props.borderColor,
    id = props.id,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var isHorizontalMode = mode.includes('horizontal');
  var isVerticalMode = mode.includes('vertical');
  var inputRef = (0, _react.useRef)();
  var cardRef = (0, _react.useRef)();
  var renderVerticalHeadMemoized = (0, _react.useMemo)(function () {
    var renderVerticalHead = function renderVerticalHead(title, extra, theme) {
      return /*#__PURE__*/_react.default.createElement(_StyledCard.StyledCardHead, {
        className: "head",
        theme: theme,
        $borderColor: borderColor
      }, title && /*#__PURE__*/_react.default.createElement("div", {
        className: "title"
      }, title, " ", extra && extraPosition == "left" && /*#__PURE__*/_react.default.createElement("span", {
        className: "extra-left"
      }, extra)), extra && extraPosition != "left" && /*#__PURE__*/_react.default.createElement("div", {
        className: "extra"
      }, extra));
    };
    return renderVerticalHead;
  }, [title, extra]);
  var renderHorizontalHeadMemoized = (0, _react.useMemo)(function () {
    var renderHorizontalHead = function renderHorizontalHead(title, extra, theme) {
      return /*#__PURE__*/_react.default.createElement(_StyledCard.StyledCardHeadHorizontal, {
        className: "head",
        theme: theme
      }, title && /*#__PURE__*/_react.default.createElement("div", {
        className: "title"
      }, title));
    };
    return renderHorizontalHead;
  }, [title, extra]);
  var renderCoverMemoized = (0, _react.useMemo)(function () {
    var renderCover = function renderCover(cover, theme) {
      return /*#__PURE__*/_react.default.createElement(_StyledCard.StyledCardCover, {
        className: "cover",
        theme: theme
      }, cover);
    };
    return renderCover;
  }, [cover]);
  var handleClick = function handleClick(e) {
    if (e.target == cardRef.current) {
      inputRef.current.focus();
    }
    if (typeof onClick === 'function') {
      onClick();
    }
  };
  return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
    var head = null;
    var coverContent = null;
    if ((title || extra) && isVerticalMode) {
      head = renderVerticalHeadMemoized(title, extra, theme);
    }
    if ((title || extra) && isHorizontalMode) {
      head = renderHorizontalHeadMemoized(title, extra, theme);
    }
    if (cover) {
      coverContent = renderCoverMemoized(cover, theme);
    }
    return /*#__PURE__*/_react.default.createElement(_StyledCard.StyledCard, (0, _extends2.default)({
      onClick: handleClick,
      ref: cardRef,
      $bordered: bordered,
      $hoverable: hoverable,
      $selected: selected,
      className: className,
      theme: theme,
      $isVerticalMode: isVerticalMode,
      $isHorizontalMode: isHorizontalMode,
      $borderColor: borderColor
    }, rest), (title || extra) && isVerticalMode && renderVerticalHeadMemoized(title, extra, theme), coverContent, /*#__PURE__*/_react.default.createElement(_StyledCard.StyledCardBody, {
      className: "body",
      theme: theme,
      $borderColor: borderColor
    }, title && isHorizontalMode && renderHorizontalHeadMemoized(title, extra, theme), /*#__PURE__*/_react.default.createElement(_StyledCard.ContentWrapper, {
      withArrow: withArrow
    }, /*#__PURE__*/_react.default.createElement(_StyledCard.ChildrenWrapper, null, children), withArrow && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "angle-right",
      className: "card-arrow-icon"
    })), /*#__PURE__*/_react.default.createElement(_StyledCard.WidgetIdInput, {
      tabIndex: -1,
      ref: inputRef,
      id: id
    })));
  });
};
Card.propTypes = {
  /**
   * Additional CSS ui classes
   */
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  bordered: _propTypes.default.bool,
  title: _propTypes.default.string,
  hoverable: _propTypes.default.bool,
  selected: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  cover: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  extra: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  extraPosition: _propTypes.default.oneOf(['right', 'left']),
  /**
   * You can change the card in landscape or portrait view
   */
  mode: _propTypes.default.oneOf(['horizontal', 'vertical']),
  withArrow: _propTypes.default.bool,
  borderColor: _propTypes.default.oneOf(['primary', 'success', 'danger'])
};
Card.defaultProps = {
  className: '',
  bordered: true,
  hoverable: false,
  mode: 'vertical',
  withArrow: false,
  extraPosition: 'right'
};
var _default = exports.default = Card;